import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, MenuItem, Paper, Select } from '@material-ui/core';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ManufactureListTable from '../component/ManufactureListTable';
import ManufactureSearchFilterForm from '../component/ManufactureSearchFilterForm';
import { IRootStore } from '../../../../../data/store/RootStore';
import ManufactureListItem from '../../../../../data/model/manufacture/ManufactureListItem';
import { CommonError } from '../../../../../data/model/common/CommonErrors';
import ManufactureWorkListStore from '../../../../../data/store/pageStore/manufacture/ManufactureWorkListStore';
import ManufactureWork from '../../../../../data/model/manufacture/ManufactureWork';
import PTSPagination from '../../../../common/component/task/table/PTSPagination';
import PTSMessage from '../../../../../data/model/common/PTSMessage';
import WorkInfo from '../../../../../resource/data/works.json';
import { action } from 'mobx';

interface Props extends RouteComponentProps<any>, IRootStore {
    departType: string;
    stage: string;
}

const translate = (str: string) => {
    return (ManufactureListItem.Translations as any)[str];
}

@inject('rootStore')
@observer
class ManufactureListTableContainer extends React.Component<Props> {
    store = new ManufactureWorkListStore();

    globalStore = this.props.rootStore.globalStore;

    init = () => {
        this.setHeaders();
        this.store.stage = this.props.stage;
        this.store.departType = this.props.departType;
        this.store.setModeByStage();
        this.globalStore.currentTaskTitle = this.getTaskTitle();
        this.globalStore.useComment = false;
    }

    getTaskTitle = () => {
        switch (this.store.mode) {
            case ManufactureWorkListStore.ModeList.accept:
                return '제조 접수대기 목록';
            case ManufactureWorkListStore.ModeList.process:
                return '제조 작업대기 목록';
            case ManufactureWorkListStore.ModeList.search:
                return '제조 Work 목록';
            // case ManufactureWorkListStore.ModeList.shipped:
            //     return '예상 출하일 / 출하 요청일 변경 목록';
            // case ManufactureWorkListStore.ModeList.cancelShipping:
            //     return '제조 출하일 변경 요청 목록';
            // case ManufactureWorkListStore.ModeList.changeShipping:
            //     return '예상 출하일 / 출하 요청일 변경 요청 목록';
            default:
                return 'Unknown';
        }
    }

    setHeaders = () => {
        while (this.store.headers.length > 0) {
            this.store.headers.pop();
        }
        this.store.headers.push('orderNumber');
        this.store.headers.push('erpCode');
        this.store.headers.push('projectCode');
        this.store.headers.push('representativeName');
        this.store.headers.push('customerAndPI');
        this.store.headers.push('shippingRequestDate');
        // this.store.headers.push('determinedReleaseDate');
        this.store.headers.push('manufactureExpectShippingRequestDate');
        this.store.headers.push('coa');
    }

    componentDidMount = async () => {
        this.init();
        this.setStoreFromUrlQuery();
        this.globalStore.useComment = false;
        await this.getDatas();
    }

    onPageChange = async (e: any, offset: number) => {
        this.store.offset = offset;
        await this.getDatas();
    }

    // data fetch
    getDatas = async () => {
        try {
            const query = this.getFilter();
            this.syncUrlQuery(query);
            await this.store.setManufactureListData(query, this.globalStore.token);
        } catch (err) {
            if (err instanceof CommonError || err instanceof PTSMessage) {
                alert(err.message);
            }
            else {
                alert('오류 발생');
            }
        }
    }

    // build query
    getFilter = (): object => {
        const query: any = {
            skip: this.store.offset,
            limit: this.store.limit,
        };

        if (this.store.mode === ManufactureWorkListStore.ModeList.accept) {
            query.status = WorkInfo.status.running;
            query.stage = ManufactureWork.StageList.waitAccept;
        }
        else if (this.store.mode === ManufactureWorkListStore.ModeList.process) {
            query.status = WorkInfo.status.running;
            query.stage = ManufactureWork.StageList.processing;
        }
        else if (this.store.mode === ManufactureWorkListStore.ModeList.search) {
            query.status = this.store.selectedStatus;
        }

        if (this.store.selectedField && this.store.filterText) {
            query.searchField = this.store.selectedField;
            query.keyword = this.store.filterText;
        }
        if (this.store.sortField) {
            query.sortField = this.store.sortField;
            query.sortOrder = this.store.sortOrder;
        }

        return query;
    }

    setStoreFromUrlQuery = () => {
        const query = new URLSearchParams(this.props.location.search);
        const skip = query.get('skip');
        const limit = query.get('limit');
        const status = query.get('status');
        const searchField = query.get('searchField');
        const keyword = query.get('keyword');
        const sortField = query.get('sortField');
        const sortOrder = query.get('sortOrder');

        if (skip !== null && !isNaN(Number(skip))) {
            this.store.offset = Number(skip);
        }
        if (limit !== null && !isNaN(Number(limit)) && Number(limit) > 0) {
            this.store.limit = Number(limit);
        }
        if (status && this.store.mode === ManufactureWorkListStore.ModeList.search) {
            this.store.selectedStatus = status;
        }
        if (searchField) {
            this.store.selectedField = searchField;
        }
        if (keyword) {
            this.store.filterText = keyword;
        }
        if (sortField) {
            this.store.sortField = sortField;
        }
        if (sortOrder === 'asc' || sortOrder === 'desc') {
            this.store.sortOrder = sortOrder;
        }
    }

    syncUrlQuery = (query: object) => {
        const params = new URLSearchParams();
        Object.keys(query).forEach((key) => {
            const value = (query as any)[key];
            if (value !== undefined && value !== null && value !== '') {
                params.set(key, String(value));
            }
        });

        this.props.history.replace({
            pathname: this.props.location.pathname,
            search: params.toString(),
        });
    }

    // send data(form submit)
    receiptWork = async (workID: string) => {
        try {
            if (window.confirm('접수하시겠습니까?')) {
                this.globalStore.isRunning = true;
                const arr: string[] = [];
                arr.push(workID);
                const result = await this.store.requestAcceptWorks(arr, this.globalStore.token);
                if (result.data.type === 'apiErr') {
                    throw new PTSMessage({
                        message: result.data.resMessage,
                    })
                }
                alert('접수 완료');
                this.getDatas();
            }
        } catch (err) {
            if (err instanceof CommonError || err instanceof PTSMessage) {
                alert(err.message);
            }
            else {
                alert('오류 발생');
            }
        } finally {
            this.globalStore.isRunning = false;
        }
    }

    receiptWorks = async () => {
        try {
            this.globalStore.isRunning = true;
            const selectedWorkIDs: string[] = this.store.workList.filter((v) => {
                return v.checked;
            }).map((v) => {
                return v.workID;
            });
            if (selectedWorkIDs.length < 1) {
                alert('선택된 항목이 없습니다.');
                return;
            }
            if (window.confirm('선택 항목 접수 하시겠습니까?')) {
                const result = await this.store.requestAcceptWorks(selectedWorkIDs, this.globalStore.token);
                if (result.data.type === 'apiErr') {
                    throw new PTSMessage({
                        message: result.data.resMessage,
                    })
                }
                alert('접수 완료');
                this.getDatas();
            }
        } catch (err) {
            if (err instanceof CommonError || err instanceof PTSMessage) {
                alert(err.message);
            }
            else {
                alert('오류 발생');
            }
        } finally {
            this.globalStore.isRunning = false;
        }
    }

    onSearch = async (e: any) => {
        this.store.offset = 0;
        await this.getDatas();
    }

    onClear = async (e: any) => {
        this.store.offset = 0;
        this.store.onFilterClear();
        await this.getDatas();
    }

    @action
    handleStatusChange = async (e: React.ChangeEvent<any>) => {
        this.store.offset = 0;
        this.store.selectedField = '';
        this.store.filterText = '';
        this.store.onChangeDefault(e);
        await this.getDatas();
    }

    @action
    handleSort = async (field: string) => {
        this.store.offset = 0;
        if (this.store.sortField === field) {
            this.store.sortOrder = this.store.sortOrder === 'asc' ? 'desc' : 'asc';
        }
        else {
            this.store.sortField = field;
            this.store.sortOrder = 'desc';
        }
        await this.getDatas();
    }

    render() {
        return (
            <React.Fragment>
                <Grid
                    xl
                    lg
                    sm
                    spacing={1}
                    container
                    item
                    direction='column'
                    alignItems='stretch'
                    style={{ marginTop: 4 }}>
                    <Paper style={{ padding: 30 }}>
                        <Grid item xl lg sm container direction='column'>
                            <Grid
                                xl
                                lg
                                sm
                                item
                                container
                                direction='column'>
                                <Grid container item alignContent='flex-start' style={{ margin: 10 }}>
                                    {
                                        this.store.mode === ManufactureWorkListStore.ModeList.search
                                        &&
                                        <Select
                                            style={{ minWidth: 200, marginRight: 8 }}
                                            labelId='selectedStatus'
                                            onChange={this.handleStatusChange}
                                            value={this.store.selectedStatus}
                                            name='selectedStatus'>
                                            <MenuItem value={WorkInfo.status.all}>All</MenuItem>
                                            <MenuItem value={WorkInfo.status.running}>진행중</MenuItem>
                                            <MenuItem value={WorkInfo.status.paused}>중단됨</MenuItem>
                                            <MenuItem value={WorkInfo.status.finished}>완료됨</MenuItem>
                                        </Select>
                                    }
                                    <ManufactureSearchFilterForm
                                        onSearch={this.onSearch}
                                        onFilterChange={this.store.onFilterChange}
                                        onFilterClear={this.onClear}
                                        filterText={this.store.filterText}
                                        selectedField={this.store.selectedField} />
                                </Grid>
                                <Grid container item alignContent='flex-end' direction='column'>
                                    <PTSPagination
                                        limit={this.store.limit}
                                        offset={this.store.offset}
                                        total={this.store.total}
                                        onClick={this.onPageChange} />
                                </Grid>
                            </Grid>
                            <Grid xl lg sm item>
                                <ManufactureListTable
                                    receiptHandler={this.receiptWork}
                                    offset={this.store.offset}
                                    translation={translate}
                                    headers={this.store.headers}
                                    useCheckBox={this.store.mode === ManufactureWorkListStore.ModeList.accept ? true : false}
                                    datas={this.store.workList}
                                    mode={this.store.mode}
                                    numSelected={this.store.selectedNum}
                                    allSelected={this.store.allSelected}
                                    perPage={this.store.limit}
                                    receiptHeaderHandler={this.receiptWorks}
                                    sortField={this.store.sortField}
                                    sortOrder={this.store.sortOrder}
                                    onSort={this.handleSort} />
                            </Grid>
                            <Grid
                                style={{ padding: 5, margin: 20 }}
                                xl lg
                                sm
                                item
                                container
                                alignItems='flex-end'
                                direction='column'>
                                <Grid item xl lg sm>
                                    <PTSPagination
                                        limit={this.store.limit}
                                        offset={this.store.offset}
                                        total={this.store.total}
                                        onClick={this.onPageChange} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </React.Fragment>
        )
    }
}

export default withRouter(ManufactureListTableContainer);
